import {Component, OnInit, inject, input} from '@angular/core';
import {FileService} from '../file.service';
import {DataService} from "../../../services/data.service";

@Component({
    selector: 'app-file-viewer-single',
    templateUrl: './file-viewer-single.component.html',
    styleUrl: './file-viewer-single.component.scss',
})
export class FileViewerSingleComponent implements OnInit {

    private dataService = inject(DataService);
    private fileService = inject(FileService);

    FID = input.required<any>(); // Index of files table
    viewThumbnail = input<boolean>(false); // Fullscreen or thumbnail
    imageWidth = input<string | null>(null);
    imageHeight = input<string | null>(null);

    imageData: any;

    ngOnInit(): void {
        this.dataService.request('framework.File/getFile', {
            FID: this.FID(),
            thumbnail: this.viewThumbnail()
        }).subscribe(response => {
            this.imageData = response.imageData;
        });
    }

    openModal(): void {
        this.fileService.openModal.next(this.FID());
    }
}
